import React, {useEffect, useState} from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import { NumericFormat } from 'react-number-format';
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2";
import axios from 'axios'
import moment from 'moment';
import ExchangeOperationService from "../../../services/exchangeOperationService";

// ESTE ES EL MODAL DE DETALLE DE OPERACIONES DE GANANCIAS EN ARS Y USD
function ModalDetailOperations( {handleOpen, isOpen, title, type, arrayOperations, adjustment} ) {
   
    const navigate = useNavigate();
    const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));
    // const [ajuste, setAjuste] = useState('');
    const [cargando, setCargando] = useState(true)
    const [listOperations, setListOperations] = useState([]);
    let sumSpread = 0;
    // let sumAjuste = 0;

    useEffect(() => {
        if(arrayOperations !== ''){
            setCargando(true)
            ExchangeOperationService.getIntermOperationByIds(arrayOperations)
                .then((response) => {
                    setListOperations(response.data)
                })
                .catch((error) => {
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                })
                .finally(() => { setCargando(false) })
        }
    }, [arrayOperations])

    const doDownload =  async () => {
        try {
            if(arrayOperations !== ''){
                window.open(process.env.REACT_APP_API_URL+"exchange-operations/download/excel/revenue?token="+userProfile.token+'&ids='+arrayOperations, '_blank')
            }else{
                Swal.fire({
                    title: 'ERROR',
                    text: 'No hay operaciones para descargar',
                    icon: 'error',
                })
            }
        } catch (e) {
            if (axios.isAxiosError(e)) {
                const statusCode = e.response?.status
                const error = e.response?.data.errors;
                if(statusCode && statusCode !== 401){
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            }
        } 
        //finally{ setCargando(false) }
    }

    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>{title}</DialogTitle>
                <Divider />
                <DialogContent>
                    {cargando ?
                    <>
                        <div className="row">   
                            <div className="col-12 d-grid gap-2 d-md-flex justify-content-md-center">
                                <div className="d-flex justify-content-center">
                                    <div className="spinner-border text-info" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                    <table className="table table-sm table-hover dataTable dtr-column" >
                        <thead style={{backgroundColor: '#FFFFFF'}}>
                            <tr className="text-nowrap">
                                <th>#</th>
                                <th>Fecha</th>
                                <th>Comintente</th>
                                <th>Tipo</th>
                                <th>Segmento</th>
                                <th>Tipo Operación</th>
                                <th>Cantidad</th>
                                <th>Precio Base</th>
                                <th>Precio Esco</th>
                                {type === 'Ganancia' ? <th  className="text-end">AR$</th> : null}
                                <th  className="text-end">Total</th>
                                <th>Comercial</th>
                                {type === 'Ganancia' ? <th  className="text-end">Contraparte$</th> : null}
                            </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                            {listOperations.map((operation, index) => {
                                 // BEGIN GANANCIA EN ARS
                                // COMPRA CABLE (1) y COMPRA MEP (3) - VTA CABLE (2) y VTA MEP (4)
                                if(operation.currency_exchange_type_id === 1 || operation.currency_exchange_type_id === 3) {
                                    sumSpread = sumSpread + parseFloat(operation.esco_price - operation.price) * operation.qty;
                                }else if(operation.currency_exchange_type_id === 2 || operation.currency_exchange_type_id === 4) {
                                    sumSpread = sumSpread + parseFloat(operation.price - operation.esco_price) * operation.qty;
                                }
                                // END GANANCIA EN ARS

                                // BEGIN GANANCIA EN USD x CANJE
                                // CABLE A MEP (6) y MEP A CABLE (5)
                                if(operation.currency_exchange_type_id === 5) {
                                    sumSpread = sumSpread + parseFloat((operation.esco_price - operation.price) * operation.qty)/100;
                                    // (operation.esco_price - operation.price) * operation.qty)/100
                                }else if(operation.currency_exchange_type_id === 6){
                                    sumSpread = sumSpread + parseFloat((operation.price - operation.esco_price) * operation.qty)/100;
                                    // (operation.price - operation.esco_price) * operation.qty)/100
                                }
                                // END GANANCIA EN USD

                                // BEGIN GANANCIA EN USD x INSTRUMENTO
                                if(operation.exchange_type_id === 2 && operation.currency_exchange_type_id === null){
                                    if(operation.operation_type_id === 1){
                                        //COMPRA 
                                        sumSpread = sumSpread + parseFloat(operation.esco_price - operation.price) * operation.qty
                                    }else if(operation.operation_type_id === 2){
                                        //VENTA
                                        sumSpread = sumSpread + parseFloat(operation.price - operation.esco_price) * operation.qty
                                    }
                                }
                                // END GANANCIA EN USD
                                return (
                                    <tr key={operation.id}>  
                                        <td>{operation.id}</td>
                                        <td>{moment(operation.date).format('DD/MM/YYYY')}</td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            {operation.account_model.name.length > 30 ?
                                                                `${operation.account_model.name.substring(0, 30)}...` : operation.account_model.name
                                                            }
                                                        </span>
                                                    </a>
                                                    <small className="text-muted"><span className="badge bg-label-dark">{operation.account_model.account}</span></small>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    {operation.exchange_type_id === 1 ?
                                                        <small className="text-muted"><span className="badge bg-label-primary me-1">{operation.currency_exchange_type.name}</span></small>
                                                    :
                                                        <small className="text-muted"><span className="badge bg-label-dark">x Instrumento AA</span></small>
                                                    }
                                                </div>
                                            </div>                                            
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <small className="text-muted">
                                                        {operation.segment_id === 1 && <span className="badge bg-label-primary me-1">{operation.segment.name}</span>}
                                                        {operation.segment_id === 2 && <span className="badge bg-label-info me-1">{operation.segment.name}</span>}
                                                        {operation.segment_id === 3 && <span className="badge bg-label-secondary me-1">{operation.segment.name}</span>}
                                                    </small>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            {operation.operation_type_id === 1 && <span className="badge bg-label-success me-1">{operation.operation_type.name}</span>}
                                                            {operation.operation_type_id === 2 && <span className="badge bg-label-danger me-1">{operation.operation_type.name}</span>}
                                                        </span>
                                                    </a>
                                                    <small className="text-muted">
                                                        <span className="badge bg-label-dark">{operation.settlement_term.name}</span>
                                                        <span className="badge bg-label-dark">{operation.ticker}</span>
                                                    </small>
                                                    <small className="text-muted"></small>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-end">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={operation.qty} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator="," 
                                            /> 
                                        </td>
                                        <td className="text-end">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={operation.price} 
                                                decimalScale={4} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator="," 
                                                prefix={'$'}  
                                            /> 
                                        </td>
                                        <td className="text-end">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={operation.esco_price} 
                                                decimalScale={4} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator="," 
                                                prefix={'$'}  
                                            /> 
                                        </td>
                                        {type === 'Ganancia' ?
                                            <>
                                            <td className="text-end">
                                                <NumericFormat 
                                                    displayType="text" 
                                                    value={operation.price * operation.qty} 
                                                    allowLeadingZeros thousandSeparator="." 
                                                    decimalSeparator=","
                                                    prefix={'$'}  
                                                    decimalScale={2} 
                                                /> 
                                            </td>
                                            </>
                                        : null}
                                       {/* TOTAL */}
                                        {type === 'Ganancia' && (operation.currency_id === 1 || operation.currency_id === null )?
                                        // GANANCIA EN ARS
                                        <>
                                            <td className="text-end">
                                                {(operation.currency_exchange_type_id === 1 || operation.currency_exchange_type_id === 3) ||
                                                    (operation.exchange_type_id === 2 && operation.currency_id === 1 && operation.operation_type_id === 1)  ?
                                                    // COMPRA ARS
                                                    (
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={(operation.esco_price - operation.price) * operation.qty} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                            decimalScale={2} 
                                                        /> 
                                                    )
                                                :
                                                    // VENTA ARS
                                                    (
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={(operation.price - operation.esco_price) * operation.qty} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                            decimalScale={2} 
                                                        /> 
                                                    )
                                                    
                                                }
                                            </td>                                            
                                        </>
                                        : null}
                                        {/* GANANCIA EN DOLARES */}
                                        {type === 'USD' && operation.exchange_type_id === 2 && operation.currency_exchange_type_id === null ?
                                        <>
                                            <td className="text-end">
                                                {(operation.operation_type_id === 1)  ?
                                                    // COMPRA
                                                    (
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={(operation.esco_price - operation.price) * operation.qty} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                            decimalScale={2} 
                                                        /> 
                                                    )
                                                :
                                                    // VENTA 
                                                    (
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={(operation.price - operation.esco_price) * operation.qty} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                            decimalScale={2} 
                                                        /> 
                                                    )
                                                    
                                                }
                                            </td>                                            
                                        </>                                            
                                        : null}
                                         {/* GANANCIA EN DOLARES x CANJE */}
                                         {type === 'USD' && operation.exchange_type_id === 1 ?
                                            <>
                                            <td className="text-end">
                                                {(operation.currency_exchange_type_id === 5)  ?
                                                    // MEP A CABLE
                                                    (
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={((operation.esco_price - operation.price) * operation.qty)/100} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                            decimalScale={2} 
                                                        /> 
                                                    )
                                                : null}
                                                {(operation.currency_exchange_type_id === 6)  ?
                                                    // CABLE A MEP
                                                    (
                                                        <NumericFormat 
                                                            displayType="text" 
                                                            value={((operation.price - operation.esco_price) * operation.qty)/100} 
                                                            allowLeadingZeros thousandSeparator="." 
                                                            decimalSeparator=","
                                                            prefix={'$'}  
                                                            decimalScale={2} 
                                                        /> 
                                                    )
                                                :null }
                                            </td>                                            
                                            </>                                            
                                        : null}                                        
                                        <td>{operation.portfolio_manager.name}</td>
                                        {type === 'Ganancia' ?
                                            <>
                                                <td>{operation.counterparty.name}</td>
                                            </>
                                        : null}
                                    </tr>
                                    )
                                })
                            }
                        </tbody>
                        {/* FOOTER */}
                        <tfoot>
                            {type === 'Ganancia'?
                                // GANANCIA EN ARS
                                <>
                                <tr  style={{backgroundColor: "#F2F2F2", fontWeight: "bold"}}>
                                    <td colSpan="9" className="text-end">  SubTotal:  </td>
                                    <td className="text-end">
                                        <NumericFormat 
                                            displayType="text"   
                                            value={sumSpread}
                                            decimalScale={2}      
                                            allowLeadingZeros thousandSeparator="." 
                                            decimalSeparator="," 
                                            prefix={'$'}  
                                        /> 
                                    </td>
                                    <td colSpan="3"></td>
                                </tr>
                                <tr  style={{backgroundColor: "#F2F2F2", fontWeight: "bold"}}>
                                    <td colSpan="9" className="text-end">  Ajuste:  </td>
                                    <td className="text-end">
                                        <NumericFormat 
                                            displayType="text"   
                                            value={adjustment}
                                            decimalScale={2}      
                                            allowLeadingZeros thousandSeparator="." 
                                            decimalSeparator="," 
                                            prefix={'$'}  
                                        /> 
                                    </td>
                                    <td colSpan="3"></td>
                                </tr>
                                <tr  style={{backgroundColor: "#F2F2F2", fontWeight: "bold"}}>
                                    <td colSpan="9" className="text-end">  Total:  </td>
                                    <td className="text-end">
                                        <NumericFormat 
                                            displayType="text"   
                                            value={sumSpread + adjustment}
                                            decimalScale={2}      
                                            allowLeadingZeros thousandSeparator="." 
                                            decimalSeparator="," 
                                            prefix={'$'}  
                                        /> 
                                    </td>
                                    <td colSpan="3"></td>
                                </tr>
                                </>
                            : 
                                // GANANCIA EN USD
                                <>
                                <tr  style={{backgroundColor: "#F2F2F2", fontWeight: "bold"}}>
                                    <td colSpan="8" className="text-end">  Total:  </td>
                                    <td className="text-end">
                                        <NumericFormat 
                                            displayType="text"   
                                            value={sumSpread}
                                            decimalScale={2}      
                                            allowLeadingZeros thousandSeparator="." 
                                            decimalSeparator="," 
                                            prefix={'$'}  
                                        /> 
                                    </td>
                                    <td colSpan="3"></td>
                                </tr>
                                </>
                            }
                        </tfoot>
                    </table>
                    </>
                    }
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-info" onClick={() => doDownload()}> <i className="bx bx-cloud-download"></i> Descargar </button>                                                         
                </DialogActions> 
            </ModalDialog>
        </Modal>

    );
}

export default ModalDetailOperations;